import { LoginContext } from '@shared/lib/models/login-context';
import { LoginContextProvider } from '@shared/lib/providers/login-context.provider';
import { LoginTokens } from '@usana/ux/sso-auth';

/**
 * MOCK USING
 * window.Android = { mobileLoginCallback: (jsonStr) => { console.log('android mobile login got', JSON.parse(jsonStr)) }}
 */
export class AndroidLoginContextProvider extends LoginContextProvider {
  constructor() {
    super(true, LoginContext.ANDROID);
  }

  isProvided(window: Window): boolean {
    const mlc = (window as any).Android?.mobileLoginCallback;
    return typeof mlc !== 'undefined' && mlc !== null;
  }

  notifyOfLogin(window: Window, tokens: LoginTokens, redirectUri: string): void {
    (window as any).Android.mobileLoginCallback(JSON.stringify(tokens));
  }

  handleExternalRedirect(window: Window, url: string) {
    window.location.assign(url);
  }
}
